import Vue from "vue";
import VueRouter from "vue-router";
import MapComponent from "../components/MapComponent";
import MenuComponent from "../components/MenuComponent";
import MenuPopup from "../components/category_components/MenuPopup";
import SearchFrame from "../components/SearchFrame";
import PoiDetails from "../components/category_components/PoiDetails";
import DirectionsComponent from "../components/routing_components/DirectionsComponent";
import MeasureComponent from "../components/setting_components/MeasureComponent";
import Legend from "../components/setting_components/Legend";
import EventDetails from "../components/events_components/EventDetails.vue";

Vue.use(VueRouter);
// const PERSIST_QUERY_KEYS = new Set([
//   "mtk",
//   "location",
//   "q",
//   "page",
//   "pinned",
//   "toc-id",
//   "parent",

// ]);

const routes = [
  {
    path: "/",
    component: MapComponent,
    children: [
      {
        path: "",
        name: "default",
        component: MenuComponent,
        children: [
          {
            path: "lists/:view?",
            name: "pois",
            component: MenuPopup
          },
          {
            path: "search",
            name: "search",
            component: SearchFrame
          },
          {
            path: "poi/:id",
            name: "poiDetails",
            component: PoiDetails
          },
          {
            path: "measure",
            name: "measure",
            component: MeasureComponent
          },
          {
            path: "legend",
            name: "legend",
            component: Legend
          },
          {
            path: "events/:id",
            name: "eventDetails",
            component: EventDetails
          }
        ]
      },
      {
        path: "/directions",
        name: "directions",
        component: DirectionsComponent
      },
      {
        path: "/events",
        name: "events",
        component: () => import("@/components/events_components/EventsFrame.vue")
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// function pickQuery(q) {
//   const out = {};
//   Object.keys(q || {}).forEach(k => {
//     if (PERSIST_QUERY_KEYS.has(k)) out[k] = q[k];
//   });
//   return out;
// }

function hasQueryParams(route) {
  return !!Object.keys(route.query).length;
}

router.beforeEach((to, from, next) => {
  if (!hasQueryParams(to) && hasQueryParams(from)) {
    // next({
    //   name: to.name,
    //   path: to.path,
    //   params: to.params,
    //   query: pickQuery(from.query),
    // });
    next({name: to.name, path: to.path, params: to.params, query: from.query});
  } else {
    next();
  }
});

export default router;
